<div class="container-fluid">
  <div class="bg-white p-3 rounded">
    <!-- Tiêu đề Ngân Sách với biểu tượng -->
    <h3 class="h3 mb-2 text-gray-800"><i class="fas fa-wallet"></i> Ngân Sách</h3>
    
    <!-- Mô tả -->
    <p class="lead">Mô-đun Ngân Sách cho phép bạn quản lý và theo dõi ngân sách một cách hiệu quả. Bạn có thể thêm, chỉnh sửa và xóa các mục ngân sách, và thực hiện các hành động khác nhau để duy trì kiểm soát tài chính.</p>

    <!-- Nút và Dropdown -->
    
    <button class="btn btn-outline-primary" (click)="openAddDialog()">
      <i class="fas fa-plus"></i> Thêm Ngân Sách
    </button>
    <button class="btn btn-outline-warning" (click)="loadBudgets()">
      <i class="fas fa-sync-alt"></i> Tải Lại
    </button>
    
      
      <div *ngIf="loadingIndicator; else loaded">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <ng-template #loaded>

    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <ngx-datatable
            class="bootstrap"
            [rows]="budgets$"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10"
            [loadingIndicator]="loadingIndicator"
            [reorderable]="reorderable"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
          >
            <ngx-datatable-column name="Ngày Bắt Đầu" [prop]="'startDate'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.startDate | date }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Ngày Kết Thúc" [prop]="'endDate'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.endDate | date }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Mô Tả" [prop]="'description'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.description }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Tổng Số Tiền" [prop]="'totalAmount'">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span style="color: blue;">{{ row.totalAmount | currency }}$</span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Khóa Ngân Sách" [prop]="'lockBudget'">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span style="color: red;">{{ row.lockBudget ? 'Có' : 'Không' }}</span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Hành Động">
              <ng-template ngx-datatable-cell-template let-row="row">
                <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Hành Động
              </button>
              <div class="dropdown-menu">
                  <a class="dropdown-item" (click)="openEditDialog(row)">
                      <i class="fas fa-edit"></i> Chỉnh Sửa
                  </a>
                  <a class="dropdown-item"  (click)="deleteBudget(row.id)">
                      <i class="fas fa-trash"></i> Xóa
                  </a>
                  <a class="dropdown-item" (click)="lockBudget(row)">
                      <i class="fas fa-lock"></i> Khóa Ngân Sách
                  </a>
              </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </div>


   </ng-template>

  </div>

  <!-- Modal Thêm Ngân Sách -->
</div>
